export const loadingStatus = {
  init: 'init',
  loading: 'loading',
  loaded: 'loaded',
  staled: 'staled',
  ready: 'ready',
} as const;
export type TLoadingStatus = keyof typeof loadingStatus;
